/* eslint-disable import/no-cycle */
import React from 'react';
import { Link } from 'react-router-dom';
import { userDetail } from 'Stores/userDetail';
import { myLeadsState } from 'Stores/myLeads';
import * as CONSTANTS from 'Utils/constants';
import { observer } from 'mobx-react';
import { createNewListState } from 'Components/common/createNewList';
import SharedIcon from 'Components/common/SharedListIcon';
import { Utils } from 'Utils/utils';
import { ReactComponent as PlusIcon } from 'Assets/svg/plus-icon.svg';
import { ReactComponent as PrivateListIcon } from 'Assets/svg/myLeads/private-list.svg';
import { ReactComponent as SharedListIcon } from 'Assets/svg/myLeads/shared-list.svg';
import { ReactComponent as NextSlideRightIcon } from 'Assets/svg/next-slide-arrow-icon.svg';
import { ReactComponent as AddToListIcon } from 'Assets/svg/add-to-list.svg';
import { ReactComponent as LockIcon } from 'Assets/svg/lock.svg';
import Dropdown from 'Components/common/dropdown';
import { toasterState } from 'Components/common/toaster';

const createNewList = () => {
  const createSuccessCallback = (listId, listName, isSharedList) => {
    console.log('listId ', listId);

    Utils.mixpanelTrack(CONSTANTS.MX_ML_EVENTS.ML_LIST_CREATED, {
      listName,
    });
    toasterState.setToastMsg('List created successfully', 'SUCCESS-NEW');
    userDetail.addNewListToMyList({
      id: listId,
      name: listName,
      isSharedList,
    });
  };

  createNewListState.callBack = createSuccessCallback;
  createNewListState.setActionMethod('create');
  createNewListState.setShowCreateList(true);
};

export const RenderLeadsList = observer(props => {
  const { history, list, isSharedListTab } = props;

  const handleJobChange = id => {
    history.push(id ? `/my-leads/list/${id}?tab=1` : '/my-leads/list?tab=1');
  };

  const handleOnClickOtherUpdates = (id, tab) => {
    history.push(
      id ? `/my-leads/list/${id}?tab=${tab}` : `/my-leads/list?tab=${tab}`,
    );
  };

  return list.map((item, index) => {
    const { otherCount = 0, roleCount = 0, jobCount = 0 } = item;
    return (
      <div
        key={`leads-list${index}`}
        className={`leads-list-item${
          myLeadsState.selectedList.id === item.id ? ' selected' : ''
        }${
          userDetail.isContactUpdatesEnabled ? '' : ' contact-updates-disabled'
        }`}
      >
        <Link
          to={item.id ? `/my-leads/list/${item.id}` : '/my-leads/list'}
          onClick={e => {
            e.preventDefault();
            history.push(
              item.id ? `/my-leads/list/${item.id}` : '/my-leads/list',
            );
          }}
        >
          <div className="my-leads-leads-list-wrapper">
            <span className="list-name">
              <span className="show-elipsis" title={item.name}>
                {item.name}
              </span>
              <SharedIcon
                data={item}
                condition={
                  item.isSharedList &&
                  item.memberId === userDetail.userInfo.memberId
                }
              />
            </span>
            {isSharedListTab && (
              <span>{userDetail.sharedListAuthorData[item.memberId]}</span>
            )}
            <span className={`${!item.createdDate ? 'default' : ''}`}>
              {item.createdDate
                ? Utils.getFormattedDate(item.createdDate, true)
                : '- Default -'}
            </span>
            <span>{Utils.numberFormat(item.count || 0)}</span>
            <span
              className={`${
                !item.lastPurchasedDate ? 'default not-available-text' : ''
              }`}
            >
              {item.lastPurchasedDate
                ? Utils.getFormattedDate(item.lastPurchasedDate, true)
                : '- NA -'}
            </span>
            {userDetail.isContactUpdatesEnabled && (
              <span className="available-updates-div">
                <span className="updates-container updated-container-leadsList">
                  {jobCount !== 0 && (
                    <button
                      type="button"
                      className="btn updates-linear-text"
                      aria-label={`${jobCount} Job Change${
                        jobCount > 1 ? 's' : ''
                      }`}
                      onClick={e => {
                        e.stopPropagation();
                        e.preventDefault();
                        handleJobChange(item.id);
                      }}
                    >
                      <NextSlideRightIcon />
                    </button>
                  )}
                  {(otherCount !== 0 || roleCount !== 0) && (
                    <button
                      type="button"
                      className="btn updates-linear-text"
                      aria-label={`${otherCount + roleCount} Other Update${
                        otherCount + roleCount > 1 ? 's' : ''
                      }`}
                      onClick={e => {
                        e.stopPropagation();
                        e.preventDefault();
                        handleOnClickOtherUpdates(
                          item.id,
                          roleCount > 0 ? 2 : 3,
                        );
                      }}
                    >
                      <NextSlideRightIcon />
                    </button>
                  )}
                </span>
                {jobCount === 0 && otherCount === 0 && roleCount === 0 && (
                  <span className="not-available-text">- NA -</span>
                )}
              </span>
            )}
          </div>
        </Link>
      </div>
    );
  });
});

const LeadsList = observer(props => {
  const { activeListType, setActiveListType } = props;
  const showPricingPopup = (e, key) => {
    if (e !== null) e.stopPropagation();
    Utils.upgradeNowClick('list_building');
  };

  return (
    <div className="leads-container ">
      <div
        className={`leads-list-header${
          Utils.isSharedListEnabled() ? ' has-shared' : ''
        }`}
      >
        {Utils.isSharedListEnabled() && (
          <div className="tab-wrapper">
            <Link
              to="/my-leads"
              className={`tab ${activeListType === 'private' ? 'active' : ''}`}
              onClick={() => {
                if (activeListType !== 'private') setActiveListType('private');
              }}
            >
              <PrivateListIcon />
              My list
            </Link>

            <Link
              to="/my-leads?tab=shared"
              className={`tab tab-right ${
                activeListType === 'shared' ? 'active' : ''
              }`}
              onClick={() => {
                if (activeListType !== 'shared') setActiveListType('shared');
              }}
            >
              <SharedListIcon />
              Shared list
            </Link>
          </div>
        )}
        {userDetail.featureFlags !== null &&
        userDetail.featureFlags.LIST_BUILDING !== undefined &&
        userDetail.featureFlags.LIST_BUILDING === false ? (
          <Dropdown
            align="end"
            className="blocked-wrap"
            toggleElement={
              <div className="add-new-list blocked-wrap">
                <AddToListIcon className="list-icon" />
                Add New List
                <LockIcon className="dropdown-icon plus-icon lock-icon" />
              </div>
            }
          >
            <div className="phoneUpgrade filterLockUpgrade">
              <div className="phoneUpgradeWrap">
                <div className="up-text">
                  Upgrade to get full features of My Lists
                </div>
                <div
                  onClick={e => showPricingPopup(e, 'Add new')}
                  className="locked-numbers-upgrade"
                >
                  {Utils.getLockFilterBtnText()}
                </div>
              </div>
            </div>
          </Dropdown>
        ) : (
          <div
            className="new-button add-new-button new-list-button"
            onClick={createNewList}
          >
            <PlusIcon className="add-plus-icon" />
            Add New List
          </div>
        )}
      </div>
    </div>
  );
});

export { LeadsList };
export default LeadsList;
